<template>
    <div>
        <v-row>
            <v-col cols="12">
                <data-table
                        ref="table"
                        :headers="headers"
                        :items="contacts"
                        :server-items-length="contacts.length"
                        :loading="loading"
                        class="elevation-1"
                >
                    <template v-slot:item.id="{ item }">
                        {{ item.id }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      {{ getStatusText(item.status) }}
                    </template>
                    <template v-slot:item.createdAt="{ item }">
                      {{ localDateTime(item.createdAtDto) }}
                    </template>
                    <template v-slot:item.type="{ item }">
                      {{ getType(item.type) }}
                    </template>
                    <template v-slot:item.update="{ item }">
                      <v-select
                          style="width:200px"
                          v-model="item.status"
                          label="Status"
                          placeholder=" "
                          :items="statusValues"
                          item-value="value"
                          item-text="text"
                          @change="update(item)"
                      />
                    </template>
                </data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import api from '../services/api';
    import DataTable from "@/components/data-table/DataTable";
    import formatters from '@/mixins/formatters';
    import {RecordContactStatus, getStatusText} from '@/enums/RecordContactStatus';
    import permissions from '@/mixins/permissions';

    export default {
        mixins: [
            formatters,
            permissions,
        ],
        components: {
          DataTable,
        },
        data () {
            return {
                status: null,
                statuses: RecordContactStatus,
                totalContacts: 0,
                contacts: [],
                loading: true,
                headers: [
                    { text: 'ID', value: 'id', sortable: false },
                    { text: 'E-mail', value: 'email', sortable: false },
                    { text: 'Telefon', value: 'phone', sortable: false },
                    { text: 'Data', value: 'createdAt', sortable: false },
                    { text: 'Typ', value: 'type', sortable: false },
                    { text: 'Status', value: 'status', sortable: false },
                    { text: 'Akcje', value: 'update', sortable: false },
                ],
                statusValues: [
                    {
                      value: 'new',
                      text: 'Nowy'
                    },
                    {
                      value: 'processing',
                      text: 'Przetwarzanie'
                    },
                    {
                      value: 'completed',
                      text: 'Zakończone'
                    },
                ]
            }
        },
        methods: {
            async getContacts() {
                this.loading = true;

                const response = await api.get('/api/records/contacts');
                this.loading = false;

                this.contacts = response.data;
            },
            getStatusText(status) {
                return getStatusText(status);
            },
            getType(type) {
              const types = {
                'selectBdo': 'BDO',
                'standard': 'Standard',
                'premium': 'Premium'
              }

              return types[type];
            },
          update(item) {
              console.log(item);
            api.put('/api/records/contacts/' + item.id, {status: item.status});
          }
        },
        created() {
            this.getContacts();
        }
    }
</script>

<style lang="css" scoped>
    .row-pointer >>> tbody tr :hover {
        cursor: pointer;
    }
    .v-chip {
        white-space: break-spaces !important;
        line-height: 14px;
        width: 100%;
        padding: 9px;
    }

    .v-chip .v-chip__content {
        max-width: 100%;
        height: auto;
        overflow: auto;
        min-height: 32px;
        white-space: pre-wrap;
    }
</style>